import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "banner-item" }
const _hoisted_2 = { class: "banner-item__image-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "banner-item__text" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

import { getImage } from '@/models/onboarding'
import { OnboardingIntroPage } from '@/models/onboarding.types'

interface Props {
  page: OnboardingIntroPage
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SliderItem',
  props: {
    page: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "banner-item__image",
        src: _unref(getImage)(__props.page.image),
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h1", {
        class: "banner-item__title",
        innerHTML: __props.page.title
      }, null, 8, _hoisted_5),
      (__props.page.subtitle)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "banner-item__subtitle",
            innerHTML: __props.page.subtitle
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})